import React from 'react';

export class Reload extends React.Component {
	render() {
		const reload = this.props.click;

		return (
			<div className="reload">
				<button className="button icon" onClick={() => reload()}>
					<i className="fas fa-sync"></i><span className="hidden">Reload</span>
				</button>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/helpers/uiComponents/Reload.js